import { useEffect, useState  } from "react";
import { Joyride, STATUS } from "react-joyride";
import ProfileSubHeaderLinks from "../../components/profileSubHeaderLinks/ProfileSubHeaderLinks.jsx";
import { getUserInformations } from "../../services/wisdomServices/userService";
import { requestGetPaymentUrl } from "../../services/wisdomServices/additionalPaymentService";
import { getSessionItem } from "../../utils/helper/session";
import { Message } from "primereact/message";
import './Payment.css'
import { useOnboarding } from "../../context/onboardingContext.jsx";

/**
 * @function Payment
 * @returns {JSX.Element} - payment component
 */
function Payment() {
  const { runTour, finishOnboarding } = useOnboarding();
  const [paymentUrl, setPaymentUrl] = useState('')
  const [loading, setLoading] = useState(true)
  let user = getSessionItem("User")

  const donwloadFilePath = `/Wisdom-Payments-Guide.pdf`
  
  async function generatePaymentUrl(siriusEmail, personalEmail){
    let response = await requestGetPaymentUrl(siriusEmail, personalEmail)
    setPaymentUrl(response.url)

  }
  async function getUser(){
    setLoading(true)
    let response = await getUserInformations(user.id)
    await generatePaymentUrl(response.username, response.personalEmail)
    setLoading(false)
  }

  const mtInfoMessage = (
    <>
      <strong>Payment Instructions</strong><br/>
      <p>
        Please find in <a href={donwloadFilePath} download="Wisdom-Payments-Guide.pdf" id="step-paymentDoc">this link</a> instructions to setup your payment details
      </p>
    </>
  );

  const handleJoyrideCallback = (data) => {
    const { status } = data;

    if (status === STATUS.FINISHED) {
      finishOnboarding();
    }
  };

  const steps = [
    {
      content: "Now, to the most important part of your onboarding. Here you will find anything related to payments made to you, including a history!",
      placement: "center",
      title: "Payments Page",
      target: 'body'
    },
    {
      content: 
      <p>
        Please take a look at the document in the link below to get more information about this configuration.
      </p>,
      placement: "top",
      target: "#step-paymentDoc",
      title: "Payments Docs",
      spotlightClicks: true
    },
    {
      content: 
      <p>Make sure to complete this otherwise we cannot guarantee you will be paid on time</p>,
      placement: "top",
      target: "#step-payment",
      title: "Payments",
      spotlightClicks: true
    },
   {
      target: "#header-profile",
      placement: "left",
      title: "Profile Menu",
      content: (
        <p>
          This is your profile menu. From here you can access your <strong>Dashboard</strong>, <strong>Workforce Management</strong>, <strong>Profile settings</strong>, 
          the <strong>Help portal</strong>, 
          and log out of the system.
        </p>
      ),
      spotlightClicks: true,
    },
    {
      target: "#header-profile",
      placement: "left",
      title: "Help & Support",
      content: (
        <p>
          If you experience issues with systems, trackers, or applications, you can 
          access the <strong>Jira Support Portal</strong> from here clicking on <strong>Help</strong> link to report bugs 
          or request assistance.
        </p>
      ),
      spotlightClicks: true
    },
    {
      target: "#header-profile",
      placement: "left",
      content: 
      <p>
        Jiras are submitted throughout the company, when users or teams encounter issues accessing apps and resources necessary to complete their daily tasks. You can access the link using the Links menu, located on your Wisdom Dashboard, then selecting the option, "Jira Portal for system bugs". Once you have already created your profile, you'll be taken to different categories to choose from, if not, you can create your profile now. Upon selecting the relevant category, you describe the issue and provide screenshots (include your tracker log, if the issue is the tracker), then submit.
      </p>,
      title: "How do I submit a Jira?",
    },
    {
      target: "#header-profile",
      placement: "left",
      title: "Workforce Management",
      content: (
        <p>
          From the <strong>Profile menu</strong>, you can access <strong>Workforce Management</strong>. 
          This section allows you to manage your schedule, submit <strong>time-off requests</strong>, 
          and view workforce-related information. Click on the <strong>Workforce Management</strong> link to open the WFM system.
        </p>
      ),
      spotlightClicks: true
    },
    {
      target: "#header-notifications",
      placement: "bottom",
      title: "Notifications",
      content: (
        <p>
          This is your notification center. Here you will receive important updates, 
          announcements, approvals, and system alerts. Click a notification to open 
          it or navigate to the related page.
        </p>
      )
    },
    {
      target: "#step-2",
      placement: "bottom",
      title: "Downloads",
      content: (
        <p>
          Here you can download the <strong>Wisdom Tracker</strong>, install the 
          <strong>Minerva extension</strong>, or access the <strong>User Guide</strong>. 
          Make sure your tracker is installed and up to date so your work activity 
          can be recorded correctly.
        </p>
      )
    },
    {
      content: (
        <div style={{ textAlign: "center" }}>
          <h3>🎉 Welcome to Sirius!</h3>
          <p>
            Your onboarding is now complete. We are excited to have you with us!
          </p>
          <p>
            Start by checking your notifications or downloading the tracker if you
            haven't already.
          </p>
        </div>
      ),
      placement: "center",
      target: "body",
      title: "All Set!"
    }
  ];

  useEffect(() => {
    getUser()
  }, [])
  
  return (
    <div className="user-payment-container">
      <ProfileSubHeaderLinks />
      <div className="user-payment-page">
        <Joyride
          steps={steps}
          run={runTour}
          continuous
          showSkipButton
          showProgress
          scrollToFirstStep
          callback={handleJoyrideCallback}
          locale={{
            next: "Next",
            last: "Complete",
            skip: "Skip tour",
            back: "Back"
          }}
          styles={{
            options: {
              primaryColor: "#0BADDE",
              zIndex: 10000
            },
            tooltip: {
              borderRadius: "8px"
            },
            buttonNext: {
              backgroundColor: "#0BADDE"
            }
          }}
        />
        <div className="user-payment-page-message-card">
          <Message severity="info" text={mtInfoMessage}/>
        </div>
        {!loading && paymentUrl && (
          <div className="user-payments-informations-container">
            <iframe title="payment url" src={paymentUrl} id="step-payment"></iframe>

          </div>

        )}
      </div>
    </div>
  );
}

export default Payment;
